// Refresh the relative brand color across ASwap navigation. The <head> script sets it on
// first paint; this re-applies it from the swapped-in `.body-tokens` carrier, writing only
// when it actually changed (most navigations stay within one edition → no-op).
export const updateColorTokens = (): void => {
  const el = document.querySelector<HTMLElement>('.body-tokens[data-color-primary]');
  const color = el?.dataset.colorPrimary;
  if (!color) {
    return;
  }
  const root = document.documentElement;
  if (root.style.getPropertyValue('--color-primary') !== color) {
    root.style.setProperty('--color-primary', color);
  }
};
